
//ModalEmpresas.js

import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Grid } from '@mui/material';
//import Axios from 'axios';
import api from '../config/axiosConfig';

const ModalEmpresas = ({ open, handleClose, empresa, mode, fetchCompanies }) => {
  const [formData, setFormData] = useState({
    codemp: '',
    empresa: '',
    cnpjemp: '',
    email: '',
    fone: '',
    celular: '',
    dtcadastro: '',
    inscricaoest: '',
    inscricaomun: ''
  });

  useEffect(() => {
    if (empresa) {
      setFormData(empresa);
    }
  }, [empresa]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    if (mode === 'add') {
      api.post('/cadastrarempresa', formData, 
      {
      headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      })
        
        .then(response => {
          fetchCompanies();
          handleClose();
        })
        .catch(error => console.error('Erro ao adicionar empresa:', error));
    } else if (mode === 'edit') {
      api.put(`/alterarempresa/${formData.id}`, formData, 
      {
        headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      })
        .then(response => {
          fetchCompanies();
          handleClose();
        })
        .catch(error => console.error('Erro ao editar empresa:', error));
    } else if (mode === 'delete') {
      api.delete(`/excluirempresa/${formData.id}`, 
      {
      headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      })

        .then(response => {
          fetchCompanies();
          handleClose();
        })
        .catch(error => console.error('Erro ao excluir empresa:', error));
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{mode === 'add' ? 'Adicionar Empresa' : mode === 'edit' ? 'Editar Empresa' : 'Excluir Empresa'}</DialogTitle>
      <DialogContent>
        {mode !== 'delete' ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                name="empresa"
                label="Empresa"
                value={formData.empresa}
                onChange={handleChange}
                fullWidth
                margin="dense"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="email"
                label="Email"
                value={formData.email}
                onChange={handleChange}
                fullWidth
                margin="dense"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="codemp"
                label="Código da Empresa"
                value={formData.codemp}
                onChange={handleChange}
                fullWidth
                margin="dense"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="cnpjemp"
                label="CNPJ"
                value={formData.cnpjemp}
                onChange={handleChange}
                fullWidth
                margin="dense"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="fone"
                label="Fone"
                value={formData.fone}
                onChange={handleChange}
                fullWidth
                margin="dense"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="celular"
                label="Celular"
                value={formData.celular}
                onChange={handleChange}
                fullWidth
                margin="dense"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="dtcadastro"
                label="Data de Cadastro"
                value={formData.dtcadastro}
                onChange={handleChange}
                fullWidth
                margin="dense"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="inscricaoest"
                label="Inscrição Estadual"
                value={formData.inscricaoest}
                onChange={handleChange}
                fullWidth
                margin="dense"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="inscricaomun"
                label="Inscrição Municipal"
                value={formData.inscricaomun}
                onChange={handleChange}
                fullWidth
                margin="dense"
              />
            </Grid>
          </Grid>
        ) : (
          <p>Tem certeza de que deseja excluir a empresa {formData.empresa}?</p>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">Cancelar</Button>
        <Button onClick={handleSubmit} color="primary">
          {mode === 'add' ? 'Adicionar' : mode === 'edit' ? 'Salvar' : 'Excluir'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalEmpresas;